export default "__VITE_ASSET__DGX7dwfZ__"